// @flow
/* eslint-disable ta-code-conventions/has-matching-storydoc,ta-code-conventions/has-matching-test */

import { bind } from '@ta/common.api';
import DataCacher from '@ta/common.data-cacher';
import * as React from 'react';

type Props = {|
  loading: boolean,
  servletName: string,
  geoName: string,
  isGeoScoped: boolean,
  isNearby: boolean,
|};

/** Function to get the parameters for the trip search geopill api call */
const getGeoPillParams = state => {
  const paramMap = {
    servlet: state.route.page,
    geoId: state.route.geo,
    latitude: state.route.latitude,
    searchNearby: state.route.searchNearby,
  };

  const filteredParams = {};

  Object.keys(paramMap).forEach(key => {
    if (paramMap[key] !== null && typeof paramMap[key] !== 'undefined') {
      filteredParams[key] = paramMap[key];
    }
  });

  return new URLSearchParams(filteredParams);
};

/**
 * Calls the brand/geopill API endpoint and feeds the data into a given component.
 * Used for trip search geopill and the satellite trip search geopill (shows after scroll).
 * We utilize DataCacher for caching while API reloads.
 */
const GeoPillApiBinding = (WrappedComponent: React.ComponentType<any>) =>
  bind<Props, {||}, _, _, _, _>((state, stage) => {
    const apiCall = stage(`/data/1.0/brand/geopill?${getGeoPillParams(state).toString()}`);

    return newState => {
      const response = apiCall.get();
      let responseData = {};

      if (response.data) {
        responseData = {
          geoName: response.data.geoName,
          isGeoScoped: response.data.isGeoScoped,
          isNearby: response.data.isNearby,
        };
      } else {
        responseData = {
          geoName: undefined,
          isGeoScoped: false,
          isNearby: false,
        };
      }

      return {
        loading: response.loading,
        servletName: newState.meta.initialServletName,
        ...responseData,
      };
    };
  })(DataCacher()(WrappedComponent));

export default GeoPillApiBinding;
